import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Modal, Input } from 'hljd'
import store from '../store'

@observer
export default class extends Component {
  render() {
    const { isModifyShow, nick } = store
    return (
      <Modal
        title="修改备注"
        visible={isModifyShow}
        onOk={store.modifyOk}
        onCancel={store.modifyModal}
        okText="确认修改"
        afterClose={store.initRemarksModal}
      >
        <div style={{ margin: '20px 0' }}>
          <span style={{ fontSize: 14 }}>修改备注：</span>
          <Input
            placeholder="请输入账号名（最多12个字)"
            style={{ width: 300 }}
            onChange={store.changeField}
            value={nick}
          />
        </div>
      </Modal>
    )
  }
}
